import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e85301d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full grid grid-cols-3 gap-4 mt-2" }
const _hoisted_2 = { class: "mt-4 border bg-white border-primary-50 dark:bg-dark-500 dark:border-dark-400" }
const _hoisted_3 = { class: "text-xl font-bold pl-4 py-2 bg-primary-500 text-white dark:bg-dark-400 dark:border-dark-400 dark:text-dark-text" }
const _hoisted_4 = { class: "p-2 pl-4" }
const _hoisted_5 = { style: {"height":"50vh"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_part_button = _resolveComponent("part-button")!
  const _component_ProblemSelect = _resolveComponent("ProblemSelect")!
  const _component_PrimaryModal = _resolveComponent("PrimaryModal")!

  return (_openBlock(), _createBlock(_component_PrimaryModal, {
    onClickBackground: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["problem-select-wrapper max-w-screen-lg box-border px-12 py-8 m-4 overflow-y-scroll notranslate", {
        'custom-scrollbar': _ctx.isLightMode(),
        'custom-scrollbar-dark': !_ctx.isLightMode()
      }]),
        style: {"user-select":"none"}
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_part_button, {
            isSelect: 
            _ctx.problemSearchModalStatePresenter.modalState.value == 'COURSE' ||
            _ctx.problemSearchModalStatePresenter.modalState.value == 'COURSE_PROBLEM'
          ,
            onClick: _ctx.clickCourse,
            partType: "COURSE"
          }, null, 8, ["isSelect", "onClick"]),
          _createVNode(_component_part_button, {
            isSelect: 
            _ctx.problemSearchModalStatePresenter.modalState.value == 'CHALLENGE' ||
            _ctx.problemSearchModalStatePresenter.modalState.value == 'CHALLENGE_PROBLEM'
          ,
            onClick: _ctx.clickChallenge,
            partType: "CHALLENGE"
          }, null, 8, ["isSelect", "onClick"]),
          _createVNode(_component_part_button, {
            isSelect: _ctx.problemSearchModalStatePresenter.modalState.value == 'BOOKMARK',
            onClick: _ctx.clickBookmark,
            partType: "BOOKMARK"
          }, null, 8, ["isSelect", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.subtitle), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ProblemSelect, {
            onClickBookmark: _ctx.clickProblem,
            onClickChallenge: _ctx.clickChallenge,
            onClickCourse: _ctx.clickCourse,
            onClickCourseCard: _ctx.clickCourseCard,
            onClickMiddleCl: _ctx.clickMiddleCl,
            onClickProblem: _ctx.clickProblem
          }, null, 8, ["onClickBookmark", "onClickChallenge", "onClickCourse", "onClickCourseCard", "onClickMiddleCl", "onClickProblem"])
        ])
      ], 2)
    ]),
    _: 1
  }))
}